import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PAGE_URL, PRODUCT_LIST } from '@/config/AppConst';
import LogoImage from '@assets/images/logo.png';
import { MenuOutlined } from '@ant-design/icons';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [toggleMenu, setToggleMenu] = useState(false);
  const wrapperRef = useRef(null);

  const scrollToId = (targetId) => {
    console.log(targetId, 'targetId');
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate(`${PAGE_URL.HOME}`, {
        state: {
          scroll: 'section-about',
        },
      });
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setToggleMenu(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wrapperRef]);

  useEffect(() => {
    const handleScroll = () => {
      const headerHeight = 5;
      const scrollPosition =
        window.scrollY || document.documentElement.scrollTop;

      if (scrollPosition > headerHeight) {
        setToggleMenu(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <header className="header">
        <div className="container">
          <div className="content">
            <div
              className="logo pointer"
              onClick={() => navigate(`${PAGE_URL.HOME}`, {})}>
              <img width={150} src={LogoImage} alt="Pyxis Technologies" />
            </div>
            <div ref={wrapperRef}>
              <div className={`menu ${toggleMenu ? 'is-mobile' : ''}`}>
                <ul className="menu-list">
                  <li className="menu-item">
                    <a
                      className={
                        location?.pathname === PAGE_URL.ABOUT
                          ? 'active menu-link'
                          : 'menu-link'
                      }
                      onClick={() => scrollToId('section-about')}>
                      ABOUT US
                    </a>
                  </li>
                  <li className="menu-item">
                    <a
                      className={
                        location?.pathname === PAGE_URL.PRODUCT
                          ? 'active menu-link'
                          : 'menu-link'
                      }
                      onClick={() =>
                        navigate(`${PAGE_URL.PRODUCT}`, {
                          state: {
                            productName: PRODUCT_LIST.Fyndr,
                          },
                        })
                      }>
                      PRODUCTS
                    </a>
                  </li>
                  <li className="menu-item">
                    <a
                      className={
                        location?.pathname === PAGE_URL.NEWS
                          ? 'active menu-link'
                          : 'menu-link'
                      }
                      onClick={() => navigate(`${PAGE_URL.NEWS}`, {})}>
                      NEWS
                    </a>
                  </li>
                  <li className="menu-item">
                    <a
                      className={
                        location?.pathname === PAGE_URL.CONTACT
                          ? 'active menu-link'
                          : 'menu-link'
                      }
                      onClick={() => scrollToId('footer-contact')}>
                      CONTACT
                    </a>
                  </li>
                </ul>
              </div>
              <MenuOutlined
                className="menu-mobile"
                style={{ color: '#fff', fontSize: '25px' }}
                onClick={() => {
                  setToggleMenu(!toggleMenu);
                }}
              />
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default React.memo(Header);
